import { render } from "./Cofidis.vue?vue&type=template&id=3efe20b8"
import script from "./Cofidis.vue?vue&type=script&lang=js"
export * from "./Cofidis.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stefan.keyser\\source\\wearetriple\\repos\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__